import React from 'react';
import { useAuth } from '../context/AuthContext';
import BrowsePhotographersPage from './BrowsePhotographersPage';
import HomePagePhotographer from './HomePagePhotographer';

const HomePage = () => {
  const { userAttributes } = useAuth();

  if (userAttributes?.['custom:userRole'] === 'photographer') {
    return <HomePagePhotographer userName={userAttributes.given_name} />;
  }

  return <BrowsePhotographersPage />;
};

export default HomePage;
